import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import axios from 'axios';
import { toast } from 'react-toastify';
import moment from 'moment';
import { Button, Form, Col, Row, Modal } from 'react-bootstrap';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import { DataTable } from 'primereact/datatable';
import { Paginator } from 'primereact/paginator';
import { Column } from 'primereact/column';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { InputText } from 'primereact/inputtext';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/fluent-light/theme.css';
const today = new Date().toISOString().split('T')[0];

function Kycs() {
  const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState(false);
  const [userMobile, setUserMobile] = useState("");
  const currentUser = useSelector((state) => state.data);
  const [data, setData] = useState(false);
  const [pageData, setPageData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [viewIndex, setViewIndex] = useState(0);
  const [viewData, setViewData] = useState(false);
  const [viewReject, setViewReject] = useState(false);
  const [uploadData, setUploadData] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const header = (
    <div className="flex flex-wrap gap-2 align-items-center justify-content-between">
      <IconField iconPosition="right">
        <InputIcon className="pi pi-search" />
        <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." />
      </IconField>
    </div>
  );
  const handleClose = () => {
    setViewData(false);
    setViewReject(false);
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    const { status, start_date, end_date } = e.target;
    let rechargeData = {
      userMobile,
      status: status.value,
      start_date: start_date.value,
      end_date: end_date.value,
    };
    getData(rechargeData);
  };

  const fetchData = async (event) => {
    let rechargeData = {
      first: event.first,
      rows: event.rows,
      userMobile: pageData.userMobile,
      status: pageData.status,
      start_date: pageData.start_date,
      end_date: pageData.end_date,
    };
    getData(rechargeData);
  };

  const getData = async (requestData) => {
    try {
      setLoading(true);
      const response = await axios.post("/history/kycHistory", requestData);
      const { status, data, body, first, rows, totalRecords } = response.data;
      if (status) {
        setData(response.data);
        setPageData({ ...body, first, rows, totalRecords });
        setLoading(false);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const handleRejectSubmit = async (e1) => {
    e1.preventDefault();
    const { comment } = e1.target;
    const { options, e } = viewReject;
    const { name, value } = e.target;
    options.editorCallback(e.target.value);
    const response = await axios.post("/action/changeKycData", { [name]: value, kycId: options.rowData._id, comment: comment.value, userId: options.rowData.user_id });
    const { status, message, data } = response.data;
    if (status) {
      toast(message);
      handleClose();
    }
  };

  const uploadImage = async (e) => {
    const formData = new FormData();
    formData.append('id', data?.data[viewIndex]?.user_id);
    formData.append('field', e.target.name);
    formData.append('image', e.target.files[0]);
    formData.append('by', "kyc");
    try {
      const response = await axios.post("/uploadFiles", formData);
      const { image, message } = response.data;
      if (image) {
        setUploadData({ ...uploadData, [e.target.name]: image });
        toast(message);
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const viewKyc = (index) => {
    setViewIndex(index);
    setViewData(true);
  };

  const ChangeStatus = async (options, e) => {
    try {
      options.editorCallback(e.target.value);
      const { name, value } = e.target;
      if (value == "rejected") {
        setViewReject({ options, e });
      }
      else {
        const response = await axios.post("/action/changeKycData", { [name]: value, kycId: options.rowData._id, userId: options.rowData.user_id });
        const { status, message, data } = response.data;
        if (status) {
          toast(message);
          handleClose();
        }
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const onCellEditComplete = (e) => {
    let { rowData, newValue, field, originalEvent: event } = e;
    rowData[field] = newValue;
  };

  const cellEditor = (options) => {
    return (
      <select name="status" value={options.value} onChange={(e) => ChangeStatus(options, e)} onKeyDown={(e) => e.stopPropagation()}>
        <option value="pending">Pending</option>
        <option value="approved">Approved</option>
        <option value="rejected">Rejected</option>
      </select>
    );
  };

  function addSpaceBetweenCases(str) {
    return capitalizeWords(str.replace(/([a-z])([A-Z])/g, '$1 $2')).replaceAll("_", " ");
  }

  function capitalizeWords(string) {
    return string.split(' ').map(word =>
      word.charAt(0).toUpperCase() + word.slice(1)
    ).join(' ')
  }

  useEffect(() => {
    if (query.length < 2) {
      setSuggestions(false);
      setUserMobile("");
      return;
    }
    axios.get(`/users/search?q=${encodeURIComponent(query)}`).then((res) => {
      setSuggestions(res.data.users); // Adjust to your API response
      setLoading(false);
    }).catch(() => {
      setSuggestions(false);
      setLoading(false);
    });
  }, [query]);

  return (
    <div class="content-wrapper">
      <div class="row">
        <div class="col-lg-12 grid-margin stretch-card">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">Kyc Search</h4>
              <form className="searchForm" onSubmit={handleSearch}>
                <div className="row">
                  {
                    currentUser && currentUser.user_type == "admin" && (
                      <div class="col-lg-3 col-md-3">
                        <label for="user_id">Users</label>
                        {/* <select class="form-control" name="user_id">
                          <option value="">--Select--</option>
                          {
                            users && users.map(user => (
                              <option value={user._id}>{user.name}</option>
                            ))
                          }
                        </select> */}
                        <input
                          type="text"
                          class="form-control"
                          value={query}
                          onChange={(e) => setQuery(e.target.value)}
                          placeholder="Type to search..."
                        />

                        {suggestions && suggestions.length > 0 && (
                          <ul
                            style={{
                              border: "1px solid #ccc",
                              marginTop: 0,
                              paddingLeft: 0,
                              listStyleType: "none",
                              maxHeight: 150,
                              overflowY: "auto",
                              cursor: "pointer",
                            }}
                          >
                            {suggestions.map((item, idx) => (
                              <li
                                key={idx}
                                style={{ padding: "8px", borderBottom: "1px solid #eee" }}
                                onClick={() => {
                                  setQuery(item.name + "(" + item.mobile + ")"); // Adjust as per your data structure
                                  setUserMobile(item.mobile);
                                  setSuggestions(false);
                                }}
                              >
                                {item.name + "(" + item.mobile + ")"}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    )
                  }
                  <div class="col-lg-3 col-md-3">
                    <label>Status</label>
                    <select class="form-control" name="status">
                      <option value="">All</option>
                      <option value="pending">Pending</option>
                      <option value="approved">Approved</option>
                      <option value="rejected">Rejected</option>
                    </select>
                  </div>
                  <div class="col-lg-3 col-md-3">
                    <label>From Date</label>
                    <input class="form-control" type="date" name="start_date" max={today} />
                  </div>
                  <div class="col-lg-3 col-md-3">
                    <label>To Date</label>
                    <input class="form-control" type="date" name="end_date" max={today} />
                  </div>
                  <div class="col-lg-3 col-md-3">
                    <input type="submit" className="search-btn btn btn-primary" value="Search" />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="col-lg-12 grid-margin stretch-card">
          <div class="card">
            <div class="card-body">
              {
                data && (
                  <>
                    <h4 class="card-title">
                      Kyc History
                    </h4>
                    <DataTable
                      value={data.data}
                      size="small"
                      editMode="cell"
                      globalFilter={globalFilter}
                      header={header}
                      className="custom-table" // Add custom class here
                      loading={loading}
                    >
                      <Column
                        field="index"
                        header="#"
                        sortable
                        body={(rowData, { rowIndex }) => <span data-label="#">{pageData?.first + rowIndex + 1}</span>}
                      />
                      <Column
                        field="created_at"
                        header="Date"
                        sortable
                        body={(rowData) => <span data-label="Date">{moment(rowData.created_at).format('MMM-DD-YYYY')}<br />{moment(rowData.created_at).format('hh:mm:ss A')}</span>}
                      />
                      <Column
                        field="full_name"
                        header="User(Mobile)"
                        sortable
                        body={(rowData) => <span data-label="User">{rowData?.full_name}<br />({rowData?.mobile_number})</span>}
                      />
                      <Column
                        field="email"
                        header="Email"
                        sortable
                        body={(rowData) => <span data-label="Email">{rowData.email}</span>}
                      />
                      <Column
                        field="dob"
                        header="DOB"
                        sortable
                        body={(rowData) => <span data-label="DOB">{rowData?.dob}</span>}
                      />
                      <Column
                        field="gender"
                        header="Gender"
                        sortable
                        body={(rowData) => <span data-label="Gender">{rowData.gender}</span>}
                      />
                      <Column
                        field="status"
                        header="Status"
                        sortable
                        body={(rowData) => <span data-label="Status">{capitalizeWords(rowData.status)}</span>}
                        editor={(options) => cellEditor(options)}
                        onCellEditComplete={onCellEditComplete}
                      />
                      <Column
                        field="action"
                        header="Action"
                        sortable
                        body={
                          (rowData, { rowIndex }) => (
                            <span data-label="Action">
                              <button className="btn btn-primary" onClick={(e) => viewKyc(rowIndex)}>View</button>
                            </span>
                          )
                        }
                      />
                    </DataTable>
                    <div className="card">
                      <Paginator first={pageData && pageData.first} rows={pageData && pageData.rows} totalRecords={pageData && pageData.totalRecords} rowsPerPageOptions={[5, 10, 20, 30, 40, 50, 100, 200, 300, 400, 500, 1000]} onPageChange={fetchData} />
                    </div>
                  </>
                )
              }
            </div>
          </div>
        </div>
      </div>
      {/* Modal component */}
      <Modal show={viewData} onHide={handleClose} centered size={'xl'} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>KYC Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Tabs
            defaultActiveKey="user_info"
            id="uncontrolled-tab-example"
            className="mb-3"
          >
            <Tab eventKey="user_info" title="User info">
              {
                (data && data.data && (Object.entries(data.data).length > 0)) && (
                  <>
                    <ul className="showData">
                      {Object.entries(data.data[viewIndex]).map(([key, value]) => (
                        (!["", false, true, null].includes(value) && !["_id", "user_id", "__v", "created_at", "updated_at"].includes(key) && (value.toString()).indexOf("_") == "-1") && (
                          <li key={key}>
                            <strong>{addSpaceBetweenCases(key)}:</strong>
                            <div>{value}</div>
                          </li>
                        )
                      ))}
                    </ul>
                  </>
                )
              }
            </Tab>
            <Tab eventKey="kyc_detail" title="KYC Detail">
              {
                (data && data.data && (Object.entries(data.data).length > 0)) && (
                  <>
                    <ul className="showData">
                      {Object.entries(data.data[viewIndex]).map(([key, value]) => (
                        (!["", 0, false, true, null].includes(value) && (value.toString()).indexOf("_") != "-1") && (
                          <li key={key}>
                            <strong>{addSpaceBetweenCases(key)}:</strong>
                            <div className="settingImage">
                              <img src={`${process.env.REACT_APP_BACKEND_URL}/uploads/idproof/${uploadData[key] ? uploadData[key] : value}`} />
                              <div>
                                <span><input type="file" className="form-control" name={key} onChange={uploadImage} /></span>
                              </div>
                            </div>
                          </li>
                        )
                      ))}
                    </ul>
                  </>
                )
              }
            </Tab>
          </Tabs>
        </Modal.Body>
      </Modal>
      <Modal show={viewReject} onHide={handleClose} centered size={'s'} backdrop="static">
        <Form onSubmit={handleRejectSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Reject Reasion</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div class="row">
              <div class="col-lg-12">
                <textarea className="form-control" name="comment"></textarea>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" type="submit">
              Reject
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
}

export default Kycs;
